module.exports = __webpack_public_path__ + "static/media/img_and_select_kbd.8fa53d67.png";